<footer>
    <p>&copy; 2025 SINTRASJACOL. Todos los derechos reservados.</p>
</footer>
  